/// <amd-module name="Repos/Tfvc/Common/Utils/Changeset" />
import { encodeUri } from "VSS/Platform/Util/Linking";

/**
 * Gets the artifact for the specified changeset.
 *
 * @param changesetId Id of the changeset.
 */
export function getArtifactUri(changesetId: number): string {
    return encodeUri({
        id: changesetId.toString(),
        tool: "VersionControl",
        type: "Changeset"
    });
}
